import { lazy, Suspense, useEffect, } from 'react';
// ...existing code...
import { useJsApiLoader } from '@react-google-maps/api';
import PushNotificationHandler from './PushNotificationHandler';

/// Components
import Index from "./jsx";
import { connect, useDispatch } from 'react-redux';
import {  Route, Routes, useLocation , useNavigate , useParams } from 'react-router-dom';
// action
import { checkAutoLogin } from './services/AuthService';
import { isAuthenticated } from './store/selectors/AuthSelectors';


import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import "bootstrap-icons/font/bootstrap-icons.css";


import "./css/style.css";

const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
const libraries = ['places'];

// const SignUp = lazy(() => import('./jsx/pages/Registration'));
const Login = lazy(() => {
    return new Promise(resolve => {
    setTimeout(() => resolve(import('./jsx/pages/Login')), 500);
  });
});

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
	
    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
      />
    );
  }

  return ComponentWithRouterProp;
}

function App (props) {
    const { isLoaded } = useJsApiLoader({
      googleMapsApiKey: GOOGLE_API_KEY,
      libraries,
    });
    const dispatch = useDispatch();
    const navigate = useNavigate();    
    useEffect(() => {
      checkAutoLogin(dispatch, navigate);    
    }, [dispatch, navigate]);

    let routeblog = (         
      <Routes>   
        <Route path='/login' element={<Login />} />    
      </Routes>
    );
    if (!isLoaded) {
      return <div>Loading Google Maps...</div>;
    }
    if (props.isAuthenticated) {
		  return (
			  <>
            <PushNotificationHandler isAuthenticated={props.isAuthenticated} />
            <Suspense fallback={              
                <div id="preloader">                
                    <div className="sk-three-bounce">
                        <div className="sk-child sk-bounce1"></div>
                        <div className="sk-child sk-bounce2"></div>
                        <div className="sk-child sk-bounce3"></div>
                    </div>
                </div>  
              }
            >
              <Index /> 
            </Suspense>
        </>
      );    
	}else{
		return (
			  <div className="vh-100">
            <Suspense fallback={
                <div id="preloader">
                    <div className="sk-three-bounce">
                        <div className="sk-child sk-bounce1"></div>
                        <div className="sk-child sk-bounce2"></div>
                        <div className="sk-child sk-bounce3"></div>
                    </div>
                </div>
              }
            >
                {routeblog}
                
            </Suspense>
			  </div>
		);
	}
};


const mapStateToProps = (state) => {
    return {
        isAuthenticated: isAuthenticated(state),
    };
};

export default withRouter(connect(mapStateToProps)(App)); 

